export enum ENotificationVariant {
  INFO = 'Info',
  WARNING = 'Warning',
  SUCCESS = 'Success',
  ERROR = 'Error',
}
export type TNotificationVariant =
  | ENotificationVariant.INFO
  | ENotificationVariant.WARNING
  | ENotificationVariant.SUCCESS
  | ENotificationVariant.ERROR;
